webpackJsonp([21098653631116],{

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Header;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hubspot = __webpack_require__(46);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _headerModule = __webpack_require__(730);
	
	var _headerModule2 = _interopRequireDefault(_headerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Header(_ref) {
	  var heading = _ref.heading,
	      subHeading = _ref.subHeading,
	      headerImage = _ref.headerImage,
	      mainColor = _ref.mainColor;
	
	  var requestDemoUrl = '/enterprise/request-demo?hformid=' + _hubspot.requestDemoInvisionSwitchId;
	
	  var buttons = _react2.default.createElement(
	    _spacing2.default,
	    { size: 'm', sizeM: 'l', position: 'top', type: 'margin' },
	    _react2.default.createElement(
	      'div',
	      { className: _headerModule2.default.buttons },
	      _react2.default.createElement(
	        'div',
	        { className: _headerModule2.default.leftButton },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: requestDemoUrl },
	          _react2.default.createElement(
	            _button2.default,
	            {
	              size: 'large',
	              background: mainColor,
	              hover: mainColor,
	              shape: 'rounded',
	              minWidth: 180
	            },
	            'Request a demo'
	          )
	        )
	      )
	    )
	  );
	
	  return _react2.default.createElement(
	    _pageWrap2.default,
	    { size: 'l' },
	    _react2.default.createElement(
	      'div',
	      { className: _headerModule2.default.flex },
	      _react2.default.createElement(
	        'div',
	        { className: _headerModule2.default.firstCol },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h1', size: 'xxxxl', weight: 'bold', color: 'black' },
	            heading
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 's', position: 'top', type: 'margin' },
	            _react2.default.createElement(
	              _heading2.default,
	              { tag: 'h2', size: 'xxl' },
	              subHeading
	            )
	          ),
	          buttons
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _headerModule2.default.secondCol },
	        _react2.default.createElement(
	          'div',
	          { className: _headerModule2.default.coloredBackground },
	          mainColor === 'blue' && _react2.default.createElement('div', { className: _headerModule2.default.blueChild }),
	          mainColor === 'green' && _react2.default.createElement('div', { className: _headerModule2.default.greenChild })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _headerModule2.default.image },
	          _react2.default.createElement(
	            'div',
	            { className: _headerModule2.default.imageChild },
	            _react2.default.createElement(_Image2.default, _extends({}, headerImage, { hasShadow: false, block: true }))
	          )
	        )
	      )
	    )
	  );
	}
	
	Header.propTypes = {
	  heading: _propTypes2.default.string.isRequired,
	  subHeading: _propTypes2.default.string.isRequired,
	  headerImage: _propTypes2.default.object.isRequired,
	  mainColor: _propTypes2.default.string.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Logos;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logoRow = __webpack_require__(53);
	
	var _logoRow2 = _interopRequireDefault(_logoRow);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _logos = __webpack_require__(473);
	
	var _logos2 = _interopRequireDefault(_logos);
	
	var _ArrowLink = __webpack_require__(75);
	
	var _ArrowLink2 = _interopRequireDefault(_ArrowLink);
	
	var _logosModule = __webpack_require__(731);
	
	var _logosModule2 = _interopRequireDefault(_logosModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Logos() {
	  return _react2.default.createElement(
	    'div',
	    { className: _logosModule2.default.flex },
	    _react2.default.createElement(_logoRow2.default, {
	      logos: _logos2.default,
	      align: 'center',
	      color: 'black',
	      opacity: 100,
	      spacing: 'm'
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: _logosModule2.default.cta },
	      _react2.default.createElement(
	        _align2.default,
	        { type: 'center' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/customer-stories' },
	          _react2.default.createElement(
	            _ArrowLink2.default,
	            { size: 'm', weight: 'semibold', colour: 'black' },
	            'Read case studies'
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = RequestDemo;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _requestDemoModule = __webpack_require__(732);
	
	var _requestDemoModule2 = _interopRequireDefault(_requestDemoModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RequestDemo(_ref) {
	  var _ref$backgroundColor = _ref.backgroundColor,
	      backgroundColor = _ref$backgroundColor === undefined ? 'blue' : _ref$backgroundColor,
	      image = _ref.image;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _requestDemoModule2.default.main },
	    _react2.default.createElement(
	      'div',
	      { className: _requestDemoModule2.default.wrap },
	      backgroundColor === 'green' && _react2.default.createElement(
	        'div',
	        { className: _requestDemoModule2.default.greenContainer },
	        _react2.default.createElement(
	          'div',
	          { className: _requestDemoModule2.default.left },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h2', weight: 'bold', size: 'xxxxl', color: 'white' },
	            'Switch to Marvel today'
	          ),
	          _react2.default.createElement(
	            _maxWidth2.default,
	            { value: 388 },
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'xl', color: 'white' },
	              'Speak to the team about a personalised demo of Marvel Enterprise for your team.'
	            )
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'm', type: 'margin', position: 'top' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/enterprise/request-demo' },
	              _react2.default.createElement(
	                _button2.default,
	                {
	                  size: 'extraLarge',
	                  color: 'slate',
	                  hover: 'white',
	                  background: 'white',
	                  shape: 'rounded'
	                },
	                'Request a demo'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _requestDemoModule2.default.right },
	          _react2.default.createElement(
	            'div',
	            { className: _requestDemoModule2.default.imageChild },
	            _react2.default.createElement(_Image2.default, _extends({ hasShadow: false }, image, { block: true }))
	          )
	        )
	      ),
	      backgroundColor === 'blue' && _react2.default.createElement(
	        'div',
	        { className: _requestDemoModule2.default.blueContainer },
	        _react2.default.createElement(
	          'div',
	          { className: _requestDemoModule2.default.left },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h2', weight: 'bold', size: 'xxxxl', color: 'white' },
	            'Switch to Marvel today'
	          ),
	          _react2.default.createElement(
	            _maxWidth2.default,
	            { value: 388 },
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'xl', color: 'white' },
	              'Speak to the team about a personalised demo of Marvel Enterprise for your team.'
	            )
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'm', type: 'margin', position: 'top' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/enterprise/request-demo' },
	              _react2.default.createElement(
	                _button2.default,
	                {
	                  size: 'extraLarge',
	                  color: 'slate',
	                  hover: 'white',
	                  background: 'white',
	                  shape: 'rounded'
	                },
	                'Request a demo'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _requestDemoModule2.default.right },
	          _react2.default.createElement(
	            'div',
	            { className: _requestDemoModule2.default.imageChild },
	            _react2.default.createElement(_Image2.default, _extends({ hasShadow: false }, image, { block: true }))
	          )
	        )
	      )
	    )
	  );
	}
	
	RequestDemo.propTypes = {
	  backgroundColor: _propTypes2.default.string.isRequired,
	  image: _propTypes2.default.object.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 730:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flex":"src-components-modules-CompetitorAlternatives-style----header-module---flex---3aO63 alignItems-stretch justifyContent-center marginBottom-xl breakPointM-display-flex breakPointM-textAlign-left","firstCol":"src-components-modules-CompetitorAlternatives-style----header-module---firstCol---2I4sT breakPointM-marginBottom-0 breakPointM-marginRight-l breakPointM-textAlign-left textAlign-center marginBottom-l justifyContent-center marginRight-0","buttons":"src-components-modules-CompetitorAlternatives-style----header-module---buttons---2xHYU breakPointM-flexDirection-row flexDirection-column justifyContent-start display-flex","leftButton":"src-components-modules-CompetitorAlternatives-style----header-module---leftButton---1cbOA breakPointM-paddingRight-xxs breakPointM-paddingBottom-0 paddingBottom-xs","rightButton":"src-components-modules-CompetitorAlternatives-style----header-module---rightButton---1KK23 breakPointM-paddingLeft-xxs","secondCol":"src-components-modules-CompetitorAlternatives-style----header-module---secondCol---393rz","coloredBackground":"src-components-modules-CompetitorAlternatives-style----header-module---coloredBackground---3KR-I","blueChild":"src-components-modules-CompetitorAlternatives-style----header-module---blueChild---3Dx4e","coloredBackgroundAnimation":"src-components-modules-CompetitorAlternatives-style----header-module---coloredBackgroundAnimation---3A6pH","greenChild":"src-components-modules-CompetitorAlternatives-style----header-module---greenChild---nXzyk","image":"src-components-modules-CompetitorAlternatives-style----header-module---image---1SOmV","imageChild":"src-components-modules-CompetitorAlternatives-style----header-module---imageChild---1oEe- bg-white","imageAnimation":"src-components-modules-CompetitorAlternatives-style----header-module---imageAnimation---cq3tb","hackyButton":"src-components-modules-CompetitorAlternatives-style----header-module---hackyButton---3zAhF"};

/***/ }),

/***/ 731:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flex":"src-components-modules-CompetitorAlternatives-style----logos-module---flex---2YL4I alignItems-center justifyContent-center breakPointL-display-flex breakPointL-textAlign-left","cta":"src-components-modules-CompetitorAlternatives-style----logos-module---cta---2k_-o paddingTop-l breakPointL-paddingLeft-m breakPointL-paddingTop-0"};

/***/ }),

/***/ 732:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main":"src-components-modules-CompetitorAlternatives-style----requestDemo-module---main---1LaOo textAlign-center paddingTopBottom-xl","blueContainer":"src-components-modules-CompetitorAlternatives-style----requestDemo-module---blueContainer---pH7mg position-relative centered breakPointM-display-flex breakPointM-textAlign-left textAlign-center bg-marvel","greenContainer":"src-components-modules-CompetitorAlternatives-style----requestDemo-module---greenContainer---23FZ7 position-relative centered breakPointM-display-flex breakPointM-textAlign-left textAlign-center","left":"src-components-modules-CompetitorAlternatives-style----requestDemo-module---left---3OL_B breakPointM-padding-xl paddingBottom-l paddingTop-xl","right":"src-components-modules-CompetitorAlternatives-style----requestDemo-module---right---2hOtX paddingBottom-xl paddingLeftRight-l breakPointM-paddingBottom-0 breakPointM-paddingLeft-0 breakPointM-paddingRight-xl","imageChild":"src-components-modules-CompetitorAlternatives-style----requestDemo-module---imageChild---Xn3xO","imageAnimation":"src-components-modules-CompetitorAlternatives-style----requestDemo-module---imageAnimation---2vdIi","wrap":"src-components-modules-CompetitorAlternatives-style----requestDemo-module---wrap---2LBN6 pageWrap c-black textAlign-center pageWrap-l"};

/***/ }),

/***/ 1241:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Header2x = __webpack_require__(2667);
	
	var _Header2x2 = _interopRequireDefault(_Header2x);
	
	var _DesignsIntoCode2x = __webpack_require__(2665);
	
	var _DesignsIntoCode2x2 = _interopRequireDefault(_DesignsIntoCode2x);
	
	var _HandoffPrototyping2x = __webpack_require__(2666);
	
	var _HandoffPrototyping2x2 = _interopRequireDefault(_HandoffPrototyping2x);
	
	var _PublicShare2x = __webpack_require__(2668);
	
	var _PublicShare2x2 = _interopRequireDefault(_PublicShare2x);
	
	var _SymbolSync2x = __webpack_require__(2669);
	
	var _SymbolSync2x2 = _interopRequireDefault(_SymbolSync2x);
	
	var _UserTesting2x = __webpack_require__(2670);
	
	var _UserTesting2x2 = _interopRequireDefault(_UserTesting2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var assets = {
	  header: {
	    src: _Header2x2.default,
	    maxWidth: 1000
	  },
	  designsIntoCode: {
	    alt: 'turning designs into code',
	    src: _DesignsIntoCode2x2.default,
	    maxWidth: 800
	  },
	  handoffPrototyping: {
	    alt: 'handoff preview',
	    src: _HandoffPrototyping2x2.default,
	    maxWidth: 800
	  },
	  publicShare: {
	    alt: 'share screen preview',
	    src: _PublicShare2x2.default,
	    maxWidth: 800
	  },
	  symbolSync: {
	    alt: 'syncing symbols preview',
	    src: _SymbolSync2x2.default,
	    maxWidth: 800
	  },
	  userTesting: {
	    alt: 'preview of user testing',
	    src: _UserTesting2x2.default,
	    maxWidth: 800
	  }
	};
	
	exports.default = assets;
	module.exports = exports['default'];

/***/ }),

/***/ 2665:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/DesignsIntoCode2x-e5a71cdd9938890a6f255605b6982b40.jpg";

/***/ }),

/***/ 2666:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/HandoffPrototyping2x-25f33badf49b15d9829822f7f0df0ccd.jpg";

/***/ }),

/***/ 2667:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Header2x-99be2da528d60eb33bfceecef53473ba.jpg";

/***/ }),

/***/ 2668:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/PublicShare2x-4d066898103a34f6616f8d8666642d01.jpg";

/***/ }),

/***/ 2669:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/SymbolSync2x-a467f739d555e13a668d1003cf0e9fd7.jpg";

/***/ }),

/***/ 2670:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/UserTesting2x-32d4a209d77f0ac284bc86b84f671d13.jpg";

/***/ }),

/***/ 1285:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = MarvelVsZeplin;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _assets = __webpack_require__(1241);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _metadata = __webpack_require__(22);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _ImageBlock = __webpack_require__(149);
	
	var _ImageBlock2 = _interopRequireDefault(_ImageBlock);
	
	var _Header = __webpack_require__(562);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Logos = __webpack_require__(563);
	
	var _Logos2 = _interopRequireDefault(_Logos);
	
	var _RequestDemo = __webpack_require__(564);
	
	var _RequestDemo2 = _interopRequireDefault(_RequestDemo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var facebookMeta = [{
	  name: 'og:title',
	  content: 'Searching for a Zeplin alternative?'
	}, {
	  name: 'og:site_name',
	  content: 'Marvel Vs Zeplin'
	}, {
	  name: 'og:type',
	  content: 'website'
	}, {
	  name: 'og:url',
	  content: 'https://marvelapp.com/marvel-vs-zeplin'
	}, {
	  name: 'og:description',
	  content: 'Read about Zeplin vs Marvel - compare the benefits of using Marvel for your design to developer code handoff versus Zeplin.'
	}, {
	  name: 'og:image',
	  content: 'https://marvelapp.com' + _assets2.default.header.src
	}, {
	  name: 'og:site_name',
	  content: 'Marvel Vs Zeplin'
	}];
	
	var twitterMeta = [{
	  name: 'twitter:site',
	  content: 'https://marvelapp.com/marvel-vs-zeplin'
	}, {
	  name: 'twitter:creator',
	  content: 'Marvel Vs Zeplin'
	}, {
	  name: 'twitter:title',
	  content: 'Searching for a Zeplin alternative?'
	}, {
	  name: 'twitter:image',
	  content: 'https://marvelapp.com' + _assets2.default.header.src
	}];
	
	var meta = {
	  title: _metadata2.default['marvel-vs-zeplin'].title,
	  meta: [{
	    name: 'description',
	    content: _metadata2.default['marvel-vs-zeplin'].description
	  }].concat(twitterMeta, facebookMeta),
	  header: { isLight: false },
	  footer: true
	};
	
	function MarvelVsZeplin() {
	  return _react2.default.createElement(
	    _Page2.default,
	    meta,
	    _react2.default.createElement(_Header2.default, {
	      heading: 'Designer to developer code handoff',
	      subHeading: 'Collaboration from designer to developer is essential for a smooth implementation of designs. An accurate code handoff tool will save hours of unnecessary work.',
	      headerImage: _assets2.default.header,
	      mainColor: 'green'
	    }),
	    _react2.default.createElement(_Logos2.default, null),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Turn designs into code, specs and assets',
	      copy: 'Automatically turn designs into accurate developer specifications with code, measurements and specs that you can quickly copy into your code editor, reducing errors when moving into development. Alongside that, Handoff generates all of the assets within the design file into a handy ZIP file.',
	      headingMaxWidth: 435,
	      paragraphMaxWidth: 435,
	      imageAsset: _assets2.default.designsIntoCode
	    }),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Public developer share links for easy access',
	      copy: 'Give instant access to your developers with public share links direct to the specs and assets needed to they can start building straight away. Place links in JIRA issues, spec documents, Slack and emails so the team can access what they need, when they need.',
	      headingMaxWidth: 435,
	      paragraphMaxWidth: 435,
	      imageAsset: _assets2.default.publicShare,
	      isRightAligned: true
	    }),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Keep Handoff in sync with your design system',
	      copy: 'With Marvel Handoff, you\u2019ll get access to any symbol and style names that have been set in Sketch, allowing developers to easily access any layer and see exactly what part of the design relates to the design system.',
	      headingMaxWidth: 435,
	      paragraphMaxWidth: 435,
	      imageAsset: _assets2.default.symbolSync
	    }),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Integrated prototyping',
	      copy: 'Handoff is displayed next to its interactive prototype so your developers can see exactly how the designs interact, side by side with how to to build them.',
	      headingMaxWidth: 435,
	      paragraphMaxWidth: 435,
	      imageAsset: _assets2.default.handoffPrototyping,
	      isRightAligned: true
	    }),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Validate before development',
	      copy: 'Get actionable insights prior to development with built-in usability testing tools. Gather video, voice and analytics and discover how to make your designs perform better.',
	      headingMaxWidth: 430,
	      paragraphMaxWidth: 430,
	      imageAsset: _assets2.default.userTesting
	    }),
	    _react2.default.createElement(_RequestDemo2.default, { backgroundColor: 'green', image: _assets2.default.header })
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-marvel-vs-zeplin-index-js-c8c25b993a0218087a3f.js